<template>
  <div class="qx-boxview">
    <div class="righttop-box">
      <div class="pic-box">
        <!-- <img src="@/assets/image/qx/icon_bg2.png" alt="" /> -->
        <el-image :src="playIdObj.productPic" fit="contain">
          <div slot="error" class="image-slot">
            <i class="el-icon-picture-outline" style="font-size: 30px"></i>
          </div>
        </el-image>
      </div>
      <div class="data-box">
        <div class="box-header">
          墒情实时数据
          <div class="div" style="display: flex; align-items: center">
            <!-- <div class="set-box" v-if="subsetList.length > 1">
              <el-select v-model="subsetValue" placeholder="请选择" @change="subsetValueChange">
                <el-option v-for="item in subsetList" :key="item.subDeviceNum" :label="item.subDeviceName"
                  :value="item.subDeviceNum">
                </el-option>
              </el-select>
            </div> -->
            <div class="h-right" style="margin-left: 0.375rem">
              <span v-show="playIdObj.online">采集时间：{{ collectData.time || "--" }}</span><img v-show="playIdObj.online"
                class="shuaxin" src="@/assets/image/product/shuaxin.png" alt="" @click="deviceSensorData" />
              <span v-show="!playIdObj.online">设备已离线</span>
              <img class="shezhi" :class="{ 'shezhi-lixian': !playIdObj.online }"
                src="@/assets/image/product/shezhi2.png" alt="" @click="openSetUp" />
            </div>
          </div>
        </div>
        <div class="content-box">
          <div class="ceng-list" v-if="subsetList.length > 1">
            <div class="item" :class="{ 'item_act': subsetValue == item.subDeviceNum }"
              v-for="(item, index) in subsetList" :key="index" @click="subsetValueChange(item.subDeviceNum)">{{ item.subDeviceName }}</div>
          </div>
          <div class="content" :class="{ contentmore: subsetList.length > 1, contentsmall: subsetList.length <= 1 }"
            v-if="collectData.list.length">
            <div class="item" :class="{
          mr0: (index + 1) % 6 == 0,
          mb0: isMaginBottom(index, collectData.list),
        }" v-for="(item, index) in collectData.list" :key="index">
              <img :src="makeIcons(item.dataItemCode)" alt="" />
              <div class="name">{{ item.dataItemName }}</div>
              <div class="value">
                {{ item.dataItemValue
                }}
                <template v-if="item.dataItemUnit">
                  <span class="unit" v-show="item.dataItemName != '风向'">{{
                  item.dataItemUnit
                }}</span>
                </template>
                
              </div>
            </div>
          </div>
          <div class="content-no"   v-else>
            <img src="@/assets/image/home/ZWT.png" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div class="rightbottom-box">
      <div class="box-header">
        墒情统计数据
        <div class="h-right">
          <el-form :model="tjFrom" ref="warnform" :inline="true" class="flex flex_ju_sb warnform-inline rb-form"
            :style="{ paddingRight: 0 + 'px' }">
            <div class="form-inputs">
              <el-form-item label="" :style="{ marginRight: 40 + 'px' }">
                <el-select placeholder="请选择" v-model="tjFrom.collect">
                  <el-option v-for="(item, index) in collectList" :key="index" :label="item.dataItemName"
                    :value="item.dataItemCode"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="" class="form-picker" :style="{ marginRight: 40 + 'px' }">
                <div class="picker-divs picker-divs-more">
                  <el-date-picker v-model="tjFrom.startTime" size="small" type="datetime" placeholder="选择日期"
                    popper-class="pick-poper" class="picker-div" format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss" prefix-icon=" " clear-icon="el-icon-date" :clearable="false"
                    :picker-options="pickerOptions0" :editable="false">
                  </el-date-picker>
                  <i class="pick-icon el-icon-date"></i>
                  <i class="pick-icon-yuan el-icon-time"></i>
                </div>

                <span class="pick-word">至</span>
                <div class="picker-divs picker-divs-more">
                  <el-date-picker v-model="tjFrom.endTime" size="small" type="datetime" placeholder="选择日期"
                    popper-class="pick-poper" class="picker-div" format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss" prefix-icon=" " clear-icon="el-icon-date" :clearable="false"
                    :picker-options="pickerOptions1" :editable="false">
                  </el-date-picker>
                  <i class="pick-icon el-icon-date"></i>
                  <i class="pick-icon-yuan el-icon-time"></i>
                </div>
              </el-form-item>
            </div>

            <el-form-item class="form-btns" :style="{ marginRight: 0 + 'px' }">
              <el-button type="primary" @click="searchClick">查询</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="content-box">
        <div class="echart" ref="chartLine" v-show="isLine"></div>
        <div class="table-empty chart-lines flex flex_col flex_a_c flex_ju_c" v-show="!isLine">
          <img class="table-noimg" src="@/assets/image/home/ZWT.png" alt="" />
          <div class="table-emptyword">暂无气象数据</div>
        </div>
      </div>
    </div>
    <!-- 告警信息 -->
    <Qixaingalarm ref="Qixaingalarm" :playIdObj="playIdObj"></Qixaingalarm>
  </div>
</template>

<script>
import Qixaingalarm from "../components/qixaingalarm.vue";
import {
  todayTime,
  GetPreMonthDay,
  GetNextMonthDay,
  getFormatDate,
} from "@/times/moment";
export default {
  components: { Qixaingalarm },
  props: ["playIdObj"],
  data() {
    return {
      // 气象设备信息
      qxequipment: {},
      // 采集数据
      collectData: {
        time: "", //采集时间
        online: true, //是否在线
        list: [],
      },
      list: null,
      // 图标数组
      imgList: [
        {
          dataItemCode: "WD",
          path: require("@/assets/image/qxicon/icon_wd.png"),
        },
        {
          dataItemCode: "SD",
          path: require("@/assets/image/qxicon/icon_sd.png"),
        },
        {
          dataItemCode: "TW",
          path: require("@/assets/image/qxicon/icon_wd.png"),
        },
        {
          dataItemCode: "TS",
          path: require("@/assets/image/qxicon/icon_sd.png"),
        },
        {
          dataItemCode: "KQWD",
          path: require("@/assets/image/qxicon/icon_wd.png"),
        },
        {
          dataItemCode: "KQSD",
          path: require("@/assets/image/qxicon/icon_sd.png"),
        },
        {
          dataItemCode: "YLLJ",
          path: require("@/assets/image/qxicon/icon_yllj.png"),
        },
        {
          dataItemCode: "JYL",
          path: require("@/assets/image/qxicon/icon_jyl.png"),
        },
        {
          dataItemCode: "YL",
          path: require("@/assets/image/qxicon/icon_yllj.png"),
        },
        {
          dataItemCode: "FZYL",
          path: require("@/assets/image/qxicon/icon_jyl.png"),
        },
        {
          dataItemCode: "DQYL",
          path: require("@/assets/image/qxicon/icon_qy.png"),
        },
        {
          dataItemCode: "SZQY",
          path: require("@/assets/image/qxicon/icon_qy.png"),
        },
        {
          dataItemCode: "LDWD",
          path: require("@/assets/image/qxicon/icon_ldwd.png"),
        },
        {
          dataItemCode: "FS",
          path: require("@/assets/image/qxicon/icon_fs.png"),
        },
        {
          dataItemCode: "FX",
          path: require("@/assets/image/qxicon/icon_fxx.png"),
        },
        {
          dataItemCode: "YW",
          path: require("@/assets/image/qxicon/icon_yw.png"),
        },
        {
          dataItemCode: "ZFL",
          path: require("@/assets/image/qxicon/icon_zfl.png"),
        },
        {
          dataItemCode: "ZWFS",
          path: require("@/assets/image/qxicon/icon_zwfs.png"),
        },
        {
          dataItemCode: "GZQD",
          path: require("@/assets/image/qxicon/icon_zwfs.png"),
        },
        {
          dataItemCode: "ZFS",
          path: require("@/assets/image/qxicon/icon_zfs.png"),
        },
        {
          dataItemCode: "PM25",
          path: require("@/assets/image/qxicon/2.5.png"),
        },
        {
          dataItemCode: "PM10",
          path: require("@/assets/image/qxicon/10.png"),
        },
        {
          dataItemCode: "ZY",
          path: require("@/assets/image/qxicon/zaoyin.png"),
        },
      ],
      pickerOptions0: {
        disabledDate: (time) => {
          if (this.tjFrom.endTime) {
            if (this.tjFrom.endTime != "") {
              let num = new Date(this.tjFrom.endTime).getTime();
              return time.getTime() > num;
            } else {
            }
          } else {
            return false;
          }
        },
      },
      pickerOptions1: {
        disabledDate: (time) => {
          let num = new Date().getTime();
          if (time.getTime() > num) {
            return true;
          } else {
            let startNum = new Date(this.tjFrom.startTime).getTime() - 43200000;
            if (time.getTime() < startNum) {
              return true;
            } else {
              return false;
            }
          }
        },
      },
      //采集项数组
      collectList: [],
      //表单参数
      tjFrom: {
        collect: "",
        startTime: "",
        endTime: "",
      },
      isLine: false, // 是否显示折线图
      subsetList: [], //存储墒情设备子设备数组
      subsetValue: "",
    };
  },
  methods: {
    // 判断是否有下编剧
    isMaginBottom(index, list) {
      let num = list.length % 6;
      let start = list.length - num + 1;
      if (num == 0) {
        if (index + 1 >= list.length - 6) {
          return true;
        } else {
          return false;
        }
      } else {
        if (index + 1 >= start) {
          return true;
        } else {
          return false;
        }
      }
    },
    // 查询点击
    searchClick() {
      this.deviceSensorLinedata();
    },
    // 打开设置弹层
    openSetUp() {
      this.$refs.Qixaingalarm.deviceInfo = this.playIdObj;
      this.$refs.Qixaingalarm.subDeviceInfo = this.qxequipment;
      this.$refs.Qixaingalarm.csList = this.qxequipment.itemList;
      this.$refs.Qixaingalarm.drawer = true;
      let ps = {
        deviceNum: this.playIdObj.deviceNum,
        subDeviceNum: this.qxequipment.subDeviceNum,
        terminalType: "2",
      };
      this.getquerySubSpace(ps).then((res) => {
        if (res.data) {
          this.$refs.Qixaingalarm.areaName = res.data.terminalAreaFullName;
          this.$forceUpdate();
        }
      });
    },
    // 获取子设备区域信息
    getquerySubSpace(ps) {
      return new Promise((resolve, reject) => {
        this.$http.postAction(this.$api.querySubSpace, ps).then((res) => {
          resolve(res);
        });
      });
    },
    // 折线图
    // 折线图绘制
    lineChart(xData, yData, yName, yUnit) {
      // xData = [1, 2, 3];
      // yData = [1, 2, 30000];
      // yName = "温度";
      // yUnit = "℃";
      const _this = this;
      let myChart = this.$echarts.init(this.$refs.chartLine);
      let maxY = Math.max(...yData);
      let symbolSize = 60;
      let symbolFont = 12;
      if (maxY.length <= 2) {
        symbolSize = 40;
        symbolFont = 16;
      } else if (maxY.length > 2 && maxY.length <= 3) {
        symbolSize = 50;
        symbolFont = 14;
      } else if (maxY.length > 3 && maxY.length < 4) {
        symbolSize = 60;
        symbolFont = 12;
      } else {
        symbolSize = 65;
        symbolFont = 12;
      }
      let option = {
        tooltip: {
          show: true,
          trigger: "axis",
          backgroundColor: "#fff",
          padding: [14, 17],
          axisPointer: {
            type: "line",
            lineStyle: {
              color: "#DADADA",
              type: "solid",
              width: 2,
            },
          },
          extraCssText:
            "box-shadow: 0px 0px 12px 0px rgba(76, 216, 179, 0.33);text-align:left;font-size:14px;color:#3F3F3F;letter-spacing: 1px;",
          formatter: function (param) {
            let infos = "";
            infos += `<div style="">${param[0].name}</div><div style="text-align:left;margin-top:12px;color:#2DAEA9;">${yName}：<span style="color:#2DAEA9;">${param[0].value}${yUnit}</span></div>`;
            return infos;
          },
        },
        color: "#2DAEA9",
        grid: {
          left: "6%",
          bottom: "13%",
          top: "20%",
          right: "3%",
        },
        xAxis: {
          type: "category",
          data: xData,
          // 刻度线
          axisTick: {
            show: false,
          },
          axisLine: {
            lineStyle: {
              color: "#EDEDED",
              width: 2,
            },
          },
          axisLabel: {
            color: "#6B6B6B",
            fontSize: 14,
            lineHeight: 30,
          },
          boundaryGap: false,
        },
        yAxis: {
          type: "value",
          name: "（" + yUnit + "）",
          nameTextStyle: {
            color: "#6B6B6B",
            fontSize: 14,
            align: "right",
          },
          axisLabel: {
            color: "#6B6B6B",
            fontSize: 14,
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#EDEDED",
              width: 2,
            },
          },
        },
        series: [
          {
            type: "line",
            smooth: true,
            showSymbol: false,
            symbolSize: 10,
            itemStyle: {
              borderColor: "#2DAEA9",
              borderWidth: 8,
            },
            areaStyle: {
              color: "rgba(45, 174, 169, 0.26)",
            },
            lineStyle: {
              width: 4,
            },
            markPoint: {
              symbolSize: symbolSize,
              label: {
                color: "#fff",
                fontSize: symbolFont,
              },
              data: [
                {
                  type: "max",
                  name: "最大值",
                  itemStyle: {
                    color: "#FF648C",
                  },
                },
                {
                  type: "min",
                  name: "最小值",
                  itemStyle: {
                    color: "#3EA2EF",
                  },
                },
              ],
            },
            markLine: {
              data: [
                {
                  type: "average",
                  name: "平均值",
                  lineStyle: {
                    type: "solid",
                    color: "#FFA800",
                  },
                  label: {
                    position: "middle",
                    formatter: "平均值:{c}",
                    color: "#FFA800",
                    distance: 10,
                    fontSize: 16,
                  },
                  symbol: "none",
                },
              ],
            },
            data: yData,
          },
        ],
      };
      myChart.clear();
      myChart.setOption(option);
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },

    // 请求实事数据
    deviceSensorData() {
      this.collectData.list = [];
      this.$http
        .postAction(
          this.$api.deviceSensorData +
          "?deviceId=" +
          this.playIdObj.id +
          "&subDeviceId=" +
          this.qxequipment.subDeviceNum
        )
        .then((res) => {
          // res = {
          // 	code: 200,
          // 	msg: 'ok',
          // 	data: {
          // 		arrivalTime: '2022-10-24 09:29:40',
          // 		propList: [
          // 			{
          // 				dataItemName: '雨量累计',
          // 				dataItemCode: 'YLLJ',
          // 				dataItemValue: '42.61',
          // 				dataItemUnit: 'mm',
          // 			},
          // 			{
          // 				dataItemName: '降雨量',
          // 				dataItemCode: 'JYL',
          // 				dataItemValue: '42.61',
          // 				dataItemUnit: 'mm',
          // 			},
          // 			{
          // 				dataItemName: '数字气压',
          // 				dataItemCode: 'SZQY',
          // 				dataItemValue: '42.61',
          // 				dataItemUnit: 'hpa',
          // 			},
          // 			{
          // 				dataItemName: '土壤湿度',
          // 				dataItemCode: 'TRSD',
          // 				dataItemValue: '42.61',
          // 				dataItemUnit: '%',
          // 			},
          // 			{
          // 				dataItemName: '温度',
          // 				dataItemCode: 'WD',
          // 				dataItemValue: '42.61',
          // 				dataItemUnit: '°C',
          // 			},
          // 			{
          // 				dataItemName: '湿度',
          // 				dataItemCode: 'SD',
          // 				dataItemValue: '83.88',
          // 				dataItemUnit: '%',
          // 			},
          // 		],
          // 	},
          // }
          if (res.data.propList.length) {
            // 如果在线 时间显示-- 搜索按钮不显示，采集项各项数值显示 --   bug 3966
            if (!this.playIdObj.online) {
              console.log("=====");
              this.collectData.time = "--";
              this.collectData.online = false;
            } else {
              this.collectData.time = res.data.arrivalTime;

              this.collectData.online = true;
              this.collectData.list = this.matchIcon(res.data.propList);
              console.log(this.collectData.list, "this.collectData.list");
              this.collectData.list.forEach((item) => {
                if (item.dataItemName === "风向") {
                  // 根据具体逻辑更新风向值
                  let degree = parseFloat(item.dataItemValue); // 将度数值转换为浮点数

                  // 判断风向
                  let direction = "";
                  if (degree >= 337.5 || degree < 22.5) {
                    direction = "北风";
                  } else if (degree >= 22.5 && degree < 67.5) {
                    direction = "东北风";
                  } else if (degree >= 67.5 && degree < 112.5) {
                    direction = "东风";
                  } else if (degree >= 112.5 && degree < 157.5) {
                    direction = "东南风";
                  } else if (degree >= 157.5 && degree < 202.5) {
                    direction = "南风";
                  } else if (degree >= 202.5 && degree < 247.5) {
                    direction = "西南风";
                  } else if (degree >= 247.5 && degree < 292.5) {
                    direction = "西风";
                  } else if (degree >= 292.5 && degree < 337.5) {
                    direction = "西北风";
                  }

                  item.dataItemValue = direction; // 更新风向值
                }
              });
              this.$forceUpdate();
            }

            // this.collectData.list = res.data.propList;
          } else {
            this.collectData.time = "";
            this.collectData.online = false;
            this.collectData.list = [];
          }
        });
    },
    // 匹配图标
    matchIcon(list) {
      list.forEach((item) => {
        this.imgList.forEach((item2) => {
          if (item.dataItemCode == item2.dataItemCode) {
            item.path = item2.path;
          }
        });
      });
      list.forEach((item) => {
        if (!item.path) {
          item.path = require("@/assets/image/qxicon/icon_wd.png");
        }
        if (!item.dataItemValue) {
          item.dataItemValue = "--";
        }
        // if (!item.dataItemUnit) {
        //   item.dataItemUnit = "--";
        // }
      });
      return list;
    },
    // 折线图数据
    deviceSensorLinedata() {
      let params = {
        deviceId: this.playIdObj.id,
        startTime: this.tjFrom.startTime,
        endTime: this.tjFrom.endTime,
        subDeviceId: this.qxequipment.subDeviceNum,
        dataItems: [this.tjFrom.collect],
      };
      this.$http
        .postAction(this.$api.deviceSensorLinedata, params)
        .then((res) => {
          if (res.data.xList.length) {
            this.isLine = true;
            let xData = res.data.xList;
            let yData = [];
            let yName = "";
            let yUnit = "";
            let code = "";
            res.data.yList.forEach((item, index) => {
              if (index == 0) {
                code = Object.keys(item);
              }
              yData.push(item[code]);
            });
            let arr = [];
            if (this.collectList.length) {
              arr = this.collectList.filter((item) => {
                if (item.dataItemCode == code) {
                  return item;
                }
              });
              yName = arr[0].dataItemName;
              yUnit = arr[0].unitName;
              this.$nextTick(() => {
                this.lineChart(xData, yData, yName, yUnit);
              });
            }
          } else {
            this.isLine = false;
          }
        });
    },
    // 获取子设备
    deviceSub() {
      this.$http
        .postAction(
          this.$api.deviceSub +
          "?deviceId=" +
          this.playIdObj.id +
          "&subDeviceType=1"
        )
        .then((res) => {
          if (res.data) {
            // res.data.subsetList.length = 1
            this.subsetList = res.data.subsetList;
            this.subsetValue = res.data.subsetList[0].subDeviceNum;
            this.qxequipment = res.data.subsetList[0];
            this.collectList = this.qxequipment.itemList;

            this.tjFrom.collect = this.collectList[0].dataItemCode;
            this.deviceSensorData();
            this.deviceSensorLinedata();
          } else {
            this.qxequipment = {};
          }
        });
    },
    subsetValueChange(subDeviceNum) {
      if (this.subsetValue == subDeviceNum) {
        return
      }
      this.subsetValue = subDeviceNum
      let arr = this.subsetList.filter((item) => {
        return item.subDeviceNum == this.subsetValue;
      });
      if (arr.length) {
        this.qxequipment = arr[0];
        this.collectList = this.qxequipment.itemList;

        this.tjFrom.collect = this.collectList[0].dataItemCode;
        this.deviceSensorData();
        this.deviceSensorLinedata();
      }
    },
    // 初始化
    init() {
      this.$set(this.tjFrom, "startTime", `${todayTime()} 00:00:00`);
      this.$set(this.tjFrom, "endTime", `${todayTime()} 23:59:59`);

      this.$nextTick(() => {
        this.deviceSub();
      });
    },
    makeIcons(code) {
      return require(`@/assets/image/lastData/${this.getImgByCode(code)}.png`);
    },
    getImgByCode(code) {
      let appIcon;
      switch (code) {
        case "WD":
        case "KQWD":
        case "KW":
        case "DQWD":
          appIcon = "KQWD";
          break;
        case "KQSD":
        case "SD":
        case "KS":
        case "DQSD":
          appIcon = "KQSD";
          break;
        case "TW":
        case "TRWD":
          appIcon = "TRWD";
          break;
        case "TS":
        case "TRSD":
          appIcon = "TRSD";
          break;
        case "FS":
          appIcon = "FS";
          break;
        case "FX":
          appIcon = "FX";
          break;
        case "KGD":
        case "GZQD":
        case "GZ":
        case "ZD":
          appIcon = "GZD";
          break;
        case "ZY":
          appIcon = "ZY";
          break;
        case "PM25":
          appIcon = "PM25";
          break;
        case "PM10":
          appIcon = "PM10";
          break;
        case "DQYL":
        case "SZQY":
          appIcon = "DQYL";
          break;
        case "YL":
        case "FZYL":
        case "YLLJ":
          appIcon = "YL";
          break;
        case "RJYL":
        case "YLLJ":
          appIcon = "RJYL";
          break;
        case "CO2":
        case "EYHT":
          appIcon = "CO2";
          break;
        case "YQ":
          appIcon = "YQ";
          break;
        case "TYZFS":
        case "GHYXFS":
        case "ZWFS":
        case "TYZFS":
        case "FSLJ":
          appIcon = "TYFS";
          break;
        case "SYDL":
          appIcon = "SYDL";
          break;
        case "GL":
        case "ZGL":
        case "FZGL":
        case "AXGL":
        case "BXGL":
        case "CXGL":
          appIcon = "FZGL";
          break;
        case "TEC":
        case "DDL":
          appIcon = "TRDDL";
          break;
        case "TDHL":
        case "DLZ":
          appIcon = "DAN";
          break;
        case "TLHL":
        case "LLZ":
          appIcon = "LIN";
          break;
        case "TJHL":
        case "JLZ":
          appIcon = "JIA";
          break;
        case "TPH":
        case "PH":
          appIcon = "TRPH";
          break;
        case "DY":
        case "AXDY":
        case "BXDY":
        case "CXDY":
          appIcon = "DY";
          break;
        case "DL":
        case "AXDL":
        case "BXDL":
        case "CXDL":
          appIcon = "DL";
          break;
        case "DN":
        case "ZDN":
        case "AXDN":
        case "BXDN":
        case "CXDN":
          appIcon = "DN";
          break;
        case "SW":
          appIcon = "SW";
          break;
        case "SPH":
          appIcon = "SPH";
          break;
        case "RJYQ":
          appIcon = "RJYQ";
          break;
        case "XSSSLL":
        case "SSSLL":
        case "LJLL":
          appIcon = "XSSSLL";
          break;
        case "AQ":
          appIcon = "AQ";
          break;
        case "LHQ":
          appIcon = "LHQ";
          break;
        case "LDWD":
          appIcon = "LDWD";
          break;
        case "YW":
          appIcon = "YW";
          break;
        case "ZF":
          appIcon = "ZF";
          break;
        default:
          appIcon = "errimg";
          break;
      }
      return appIcon;
    },
  },
};
</script>

<style lang="scss" scoped>
.qx-boxview {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  .box-header {
    height: 16.53%;
    box-sizing: border-box;
    border-bottom: 1px solid #f1f1f1;
    font-size: 0.225rem;
    font-family: Microsoft YaHei;
    padding: 0.3rem;
    font-weight: bold;
    color: #454545;
    text-align: left;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .h-right {
      font-size: 0.175rem;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #666666;
      display: flex;
      align-items: center;

      .shuaxin {
        cursor: pointer;
        margin-left: 0.2rem;
      }

      .shezhi {
        cursor: pointer;
        margin-left: 0.4rem;
      }

      .shezhi-lixian {
        pointer-events: none;
        filter: grayscale(1);
      }
    }
  }

  .righttop-box {
    height: 48.8%;
    display: flex;
    justify-content: space-between;

    .pic-box {
      width: 21.77%;
      height: 100%;
      background: #ffffff;
      border-radius: 0.125rem;
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        height: 86.3%;
      }

      ::v-deep .el-image {
        width: 80%;
        height: 86.3%;

        .image-slot {
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }

    .data-box {
      width: 76.77%;
      height: 100%;
      background: #ffffff;
      border-radius: 0.125rem;

      .content-box {
        height: 83.47%;
        width: 100%;

        box-sizing: border-box;
        padding: 0.3rem 0.0875rem 0.3rem 0.3rem;
        display: flex;
        align-items: center;

        .ceng-list {
          width: 134px;
          height: 100%;
          margin-right: .375rem;
          margin-left: .125rem;
          overflow: auto;

          .item {
            cursor: pointer;
            margin-top: .175rem;
            width: 1.675rem;
            height: .9875rem;
            background: #FFFFFF;
            border-radius: .125rem;
            border: 1px solid #D2D2D2;
            text-align: center;
            line-height: 1.5;
            display: flex;
            align-items: center;
            justify-content: center;
            box-sizing: border-box;
            font-family: Microsoft YaHei;
            font-weight: 400;
            font-size: 16px;
            color: #9B9B9B;

            &:nth-child(1) {
              margin-top: 0;
            }
          }

          .item_act {
            color: #2DAEA9;
            border-color: #2DAEA9;
          }
        }

        .content {
          // width: 100%;
          flex: 1;
          height: 100%;
          box-sizing: border-box;
          overflow: auto;
          display: flex;
          flex-wrap: wrap;

          &::-webkit-scrollbar {
            width: 6px;
            height: 0px;
            background-color: transparent;
          }

          &::-webkit-scrollbar-track {
            border-radius: 6px;
            background-color: transparent;
          }

          &::-webkit-scrollbar-thumb {
            border-radius: 6px;
            background-color: rgba(45, 174, 169, 0.2);
          }

          .item {
            width: 1.875rem;
            height: 1.575rem;
            background: #f2f8f9;
            border-radius: 0.125rem;
            margin-right: 0.275rem;
            margin-top: 0.275rem;
            box-sizing: border-box;
            padding: 0.1875rem 0;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: center;

            img {
              width: 0.5rem;
              height: 0.5rem;
            }

            .name {
              font-size: 0.2rem;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #2daea9;
            }

            .value {
              font-size: 0.3rem;
              font-family: Microsoft YaHei;
              font-weight: bold;
              color: #2daea9;
            }
          }

          .mr0 {
            // margin-right: 0;
          }

          .mb0 {
            // margin-bottom: 0;
          }
        }

        .content-no {
          // width: 100%;
          flex: 1;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .contentmore {
          .item {
            width: 2.2875rem;
            &:nth-child(4n) {
              margin-top: 0;
            }
            &:nth-child(1),
            &:nth-child(2),
            &:nth-child(3),
            &:nth-child(4){
              margin-top: 0;
            }
          }
        }
        .contentsmall {
          .item {
            width: 2.2875rem;
            &:nth-child(5n) {
              margin-top: 0;
            }
            &:nth-child(1),
            &:nth-child(2),
            &:nth-child(3),
            &:nth-child(4),
            &:nth-child(5) {
              margin-top: 0;
            }
          }
        }
        
      }
    }
  }

  .rightbottom-box {
    width: 100%;
    height: 48.8%;
    background: #ffffff;
    border-radius: 0.125rem;

    .content-box {
      height: 83.47%;
      width: 100%;

      .echart {
        width: 100%;
        height: 100%;
      }

      .table-empty {}

      .chart-lines {
        height: 85%;
      }

      .table-noimg {
        width: 3rem;
      }

      .table-emptyword {
        color: #c8c8c8;
        font-size: 0.23rem;
      }
    }
  }
}
</style>